const PinIcon = ({ size, otherProps }) => (
  <svg
    fill="currentColor"
    height={size}
    viewBox="0 -960 960 960"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...otherProps}
  >
    <path d="m640-480 80 80v80H520v240l-40 40-40-40v-240H240v-80l80-80v-280h-40v-80h400v80h-40zm-286 80h252l-46-46v-314H400v314zm126 0" />
  </svg>
);

export default PinIcon;
